/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win3_DInputs */

const en_wc_vs_win3_d = /** @type {(inputs: Wc_Vs_Win3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word has no Linux version. WordCraft runs natively on Linux (x86_64, ARM64, RISC-V) and FreeBSD.`)
};

/**
* | output |
* | --- |
* | "Word has no Linux version. WordCraft runs natively on Linux (x86_64, ARM64, RISC-V) and FreeBSD." |
*
* @param {Wc_Vs_Win3_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win3_d = /** @type {((inputs?: Wc_Vs_Win3_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win3_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win3_d(inputs)
});
export { wc_vs_win3_d as "wc.vs.win3.d" }